/* HanysLux PDP — gallery swap, variant resolver, sticky ATC. Loaded only on product templates.
   Add-to-cart itself is handled by hl-home.js (intercepts the form → /cart/add.js → opens drawer). */
(function () {
  var form = document.querySelector('.hl-atc-form') || document.querySelector('form[action*="/cart/add"]');
  var dataEl = document.querySelector('[data-hl-variants]');
  if (!form || !dataEl) return;
  var variants = JSON.parse(dataEl.textContent || '[]');
  var idInput = form.querySelector('[data-variant-id]');
  var atc = form.querySelector('[data-hl-atc]');
  var mainImg = document.getElementById('mainImg');

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  // current selected value per option group (in option order)
  var selected = [];
  form.querySelectorAll('.opt__btns').forEach(function (g, i) {
    var s = g.querySelector('.opt__btn.is-selected') || g.querySelector('.opt__btn');
    selected[i] = s ? s.getAttribute('data-value') : null;
  });

  function matchVariant() {
    return variants.find(function (v) {
      var opts = v.options || [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return opts[i] === val; });
    });
  }

  function setPrices(text) {
    document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = text; });
  }

  function update() {
    var v = matchVariant();
    if (v) {
      if (idInput) idInput.value = v.id;
      setPrices(money(v.price));
      if (v.featured_image && v.featured_image.src && mainImg) {
        mainImg.src = v.featured_image.src;
        document.querySelectorAll('.thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') && t.getAttribute('data-full').split('?')[0] === v.featured_image.src.split('?')[0]);
        });
      }
      setAvailability(v.available);
    } else {
      setAvailability(false);   // impossible option combo -> treat as unbuyable
    }
  }

  /* Sold-out must change the LABEL, not just grey the button — a faded "Add to cart" reads as
     a broken button, not as out of stock. Mirrors the server-side render in product.liquid. */
  var atcAdd = atc && atc.querySelector('[data-atc-add]');
  var atcSold = atc && atc.querySelector('[data-atc-soldout]');
  function setAvailability(ok) {
    if (atc) {
      atc.disabled = !ok;
      if (atcAdd) atcAdd.hidden = !ok;
      if (atcSold) atcSold.hidden = ok;
    }
    var sb = document.querySelector('[data-hl-atc-sticky]');
    if (sb) { sb.disabled = !ok; sb.textContent = ok ? 'Add to cart' : 'Sold out'; }
  }

  // option buttons
  form.querySelectorAll('.opt__btns').forEach(function (group) {
    group.querySelectorAll('.opt__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.opt__btn').forEach(function (x) { x.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var oi = parseInt(btn.getAttribute('data-opt'), 10);
        selected[oi] = btn.getAttribute('data-value');
        var lab = form.querySelector('[data-opt-current="' + oi + '"]');
        if (lab) lab.textContent = btn.textContent;
        update();
      });
    });
  });
  update();

  // gallery thumbnails
  document.querySelectorAll('.thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      if (mainImg) mainImg.src = b.getAttribute('data-full');
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
    });
  });

  // sticky ATC — show whenever the main Add-to-cart is off-screen
  var sticky = document.getElementById('stickybar');
  if (atc && sticky && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        sticky.classList.toggle('show', !en.isIntersecting);
        sticky.setAttribute('aria-hidden', en.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    io.observe(atc);
  }
  var stickyBtn = document.querySelector('[data-hl-atc-sticky]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }
})();
